export class Calendar {
  constructor(http) {
    this.http = http;
  }

  fetchCalendar(startDate, endDate, status) {
    return this.http
      .get(`calendar`, { params: { startDate, endDate, status: status.value } })
      .then(response => response.data);
  }

  fetchStatuses() {
    return this.http
      .get('/mocks/calendar/statuses.json', { baseURL: '/' })
      .then(response => response.data);
  }

  fetchGrouping() {
    return this.http
      .get('/mocks/calendar/grouping.json', { baseURL: '/' })
      .then(response => response.data);
  }
}
